/** Small display helpers shared across screens. */
export const safeToFixed = (value: unknown, decimals: number): string => {
  const num = Number(value)
  return Number.isFinite(num) ? num.toFixed(decimals) : (0).toFixed(decimals)
}

export const round = (v: unknown, d = 0): number => {
  const n = Number(v)
  if (!Number.isFinite(n)) return 0
  const f = Math.pow(10, d)
  return Math.round(n * f) / f
}

export const titleCase = (s: string): string =>
  (s || '').replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())

const isPlainObject = (v: unknown): v is Record<string, unknown> => {
  if (v === null || typeof v !== 'object') return false
  const proto = Object.getPrototypeOf(v)
  return proto === Object.prototype || proto === null
}

/**
 * Firestore rejects undefined values — strip them deeply (mirrors
 * FavoritesActions.stripUndefined). Only plain objects and arrays are walked;
 * SDK values (FieldValue sentinels such as serverTimestamp(), Timestamp, Date)
 * are passed through untouched so they keep their transforms.
 */
export const stripUndefined = <T>(value: T): T => {
  if (value === undefined || value === null) return value
  if (Array.isArray(value)) return value.map(stripUndefined).filter((v) => v !== undefined) as unknown as T
  if (isPlainObject(value)) {
    const out: Record<string, unknown> = {}
    for (const key of Object.keys(value)) {
      const cleaned = stripUndefined(value[key])
      if (cleaned !== undefined) out[key] = cleaned
    }
    return out as T
  }
  return value
}
